<template>
    <div>
        <AppInput
            :name="errorLabel || label"
            :rules="rules"
            :label="label"
            v-slot="{errors, valid}"
            :model-value="displayTime"
        >
            <v-text-field
                type="time"
                :model-value="displayTime"
                @update:model-value="onChange"
                label=""
                variant="outlined"
                density="compact"
                prepend-inner-icon="mdi-clock-outline"
                :error-messages="errors && errors.length > 0 ? [''] : []"
            ></v-text-field>
        </AppInput>
    </div>
</template>

<script>
import AppInput from "@/components/forms/AppInput";

export default {
    name: "AppFormTimePicker",
    components: {AppInput},
    props: {
        modelValue: {
            required: false
        },
        value: {
            required: false
        },
        label: {
            type: String,
            default: 'Time'
        },
        errorLabel: {
            type: String
        },
        rules: {}
    },
    emits: ['update:modelValue', 'input'],
    computed: {
        currentValue() {
            return this.modelValue !== undefined ? this.modelValue : this.value;
        },
        displayTime() {
            const val = this.currentValue;
            if (!val) return '';
            // Convert {hour, minute, amPm} object to HH:mm 24-hour string
            if (typeof val === 'object' && 'hour' in val) {
                let h = val.hour;
                const m = val.minute;
                const amPm = (val.amPm || '').toLowerCase();
                if (amPm === 'pm' && h !== 12) h += 12;
                if (amPm === 'am' && h === 12) h = 0;
                return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
            }
            return val;
        }
    },
    methods: {
        onChange(timeStr) {
            if (!timeStr) {
                this.$emit('update:modelValue', null);
                this.$emit('input', null);
                return;
            }
            const parts = timeStr.split(':');
            let h = parseInt(parts[0]);
            const m = parseInt(parts[1]);
            let amPm = 'am';
            if (h >= 12) {
                amPm = 'pm';
                if (h > 12) h -= 12;
            }
            if (h === 0) h = 12;
            const result = { hour: h, minute: m, amPm: amPm };
            this.$emit('update:modelValue', result);
            this.$emit('input', result);
        }
    }
}
</script>

<style scoped>
</style>
